import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import { copyPeriod } from '../../../actions/periods'
import Confirmation from '../../../components/Confirmation/Confirmation'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import Table from '../../../components/Table'
import { createNotification } from '../../../components/Notifications/Notifications'

export default function CopyPeriod({ closeModal, data }) {
  const dispatch = useDispatch()
  const { loading } = useSelector(state => state.periods);
  const { schoolYears } = useSelector(state => state.common);
  const { year } = data || {}
  const [toYear, setToYear] = useState(0)
  const [confirmOverwrite, setConfirmOverwrite] = useState(false)

  useEffect(() => {
    setToYear(0)
    setConfirmOverwrite(false)
  }, [data])

  const schoolYearsMinus = schoolYears?.filter(y => +y.xp_key !== +year) || []

  const handleClick = (xp_key) => setToYear(xp_key)

  // Сервер сам решает: 409 - распорядок приёмника уже есть, нужно подтверждение (overwrite=true повторно);
  // 400 - нельзя (тот же год либо приёмник используется в расписаниях, тогда есть result.schedules)
  const runCopy = async (overwrite) => {
    const result = await dispatch(copyPeriod({ source_year_id: year, target_year_id: toYear, overwrite }))
    if (!result.ok) {
      if (result.requiresConfirmation) {
        setConfirmOverwrite(true)
        return
      }
      const text = result.schedules?.length ? `${result.message}: ${result.schedules.join(', ')}` : result.message
      createNotification('error', text)
      return
    }
    createNotification('success', 'Распорядок скопирован')
    closeModal()
  }

  const handleCopy = async () => {
    if (!toYear) {
      createNotification('error', 'Выберите год')
      return
    }
    await runCopy(false)
  }

  const acceptOverwrite = async () => {
    setConfirmOverwrite(false)
    await runCopy(true)
  }

  const rejectOverwrite = () => setConfirmOverwrite(false)

  const renderRow = (schoolYear) => {
    const { xp_key, name } = schoolYear
    return (
      <tr key={xp_key}>
        <td
          className={cn([+xp_key === +toYear ? styles.active : ''])}
          onClick={() => handleClick(xp_key)}
        >{name}</td>
      </tr>
    )
  }

  return (
    <>
      {confirmOverwrite && (
        <Confirmation
          title='За выбранный год присутствует учебный распорядок. Перезаписать?'
          acceptConfirmation={acceptOverwrite}
          rejectConfirmation={rejectOverwrite}
        />
      )}
      <div className={styles.modalMain}>
        <div className={styles.yearBox}>
          <Table style={{ marginTop: '2rem', backgroundColor: 'white' }} maxHeight='50vh'>
            <thead>
              <tr className={styles.thead}>
                <th style={{ backgroundColor: '#3689FF', color: 'white' }}>Год</th>
              </tr>
            </thead>
            <tbody>
              {schoolYearsMinus.map(renderRow)}
            </tbody>
          </Table>
        </div>
      </div>
      <ModalFooter handleSubmit={handleCopy} closeModal={closeModal} loading={loading} />
    </>
  )
}
